require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-social-media-social-scheduling-posting.json") })
        }
      }, "path---services-social-media-social-scheduling-posting");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-social-media-social-scheduling-posting!./.cache/json/services-social-media-social-scheduling-posting.json
// module id = 782
// module chunks = 231608221292675